import { ListParams } from "@/types/Pages";
import { create } from "zustand";

import { getUnreadCount } from "@/apis/user";
import { FetchApi } from "@/types/Api";
export type MsgStatus = "Unread" | "Read";
export type MsgItem = {
  content: string;
  contentId: number;
  createTime: string;
  status: MsgStatus;
  title: string;
};
export type FetchUserMsgData = {
  list: MsgItem[];
  total: number;
  options: any;
};

export type FetcUserMsgParams = ListParams;

type StoreState = {
  loading: boolean;
  list: MsgItem[];
  total: number;
  params: FetcUserMsgParams;
  unReadCount: number;
};

interface StoreActions {
  //(add) => set((state) => ({ variable: (state.variable += add) })),
  fetchList: (
    action: FetchApi<FetchUserMsgData, FetcUserMsgParams>,
    params: FetcUserMsgParams,
  ) => void;
  loadMore: (
    action: FetchApi<FetchUserMsgData, FetcUserMsgParams>,
    params: FetcUserMsgParams,
  ) => void;
  setParams?: (params: ListParams<FetcUserMsgParams>) => void;
  setLoading?: (loading: boolean) => void;
  setTotal?: (total: number) => void;
  setList?: (list: MsgItem[]) => void;
  fetchUnreadCount: () => void;
}

type Store = StoreState & StoreActions;
const store = (set: any, get: any) => ({
  loading: false,
  list: [],
  total: 0,
  unReadCount: 0,
  params: {
    page: 1,
    pageSize: 20,
  },
  fetchUnreadCount: async () => {
    set({ loading: true });
    const { data } = await getUnreadCount({});
    set({
      unReadCount: data?.total || 0,
    });
  },

  fetchList: async (
    action: FetchApi<FetchUserMsgData, FetcUserMsgParams>,
    params: FetcUserMsgParams,
  ) => {
    const result = await action(params);
    set({ loading: false });
    if (result.data) {
      const { list, total } = result.data;
      set({ list, total, params });
    }

    return result;
  },

  loadMore: async (
    action: FetchApi<FetchUserMsgData, FetcUserMsgParams>,
    params: FetcUserMsgParams,
  ) => {
    set({ loading: true });
    const result = await action(params);
    set({ loading: false });
    if (result.data) {
      const { list, total } = result.data;
      set({ list: get().list.concat(list), total, params });
    }

    return result;
  },
});

export const useUserMsgStore = create<Store>(store);
